import Service from "../../AuthService";

const Payment = {
    getPayments(params) {
        return Service.get("/payment", {
            params: params
        })
    },
    getPaymentById(id) {
        return Service.get("/payment/" + id)
    },
    createPayment(data) {
        return Service.post("/payment", data)
    },
    updatePayment(id, data) {
        return Service.put("/payment/" + id, data)
    },
    deletePayment(id) {
        return Service.delete("/payment/" + id)
    },
    getDataSumary(data) {
        return Service.get("/print_payment_salary_report_new?start_date=2022-10-01&end_date=2022-10-31&employee_id=&department_id=&type=ค่าประกันความเสียหาย")
    }
}

export default Payment
